/* Vue */
import Vue from 'vue';
import store from '@js/store/index.js';
import DantesIcon from '@js/components/DantesIcon.js';
import DantesPlugin from '@js/plugins/dantes.js';
import DantesValidation from '@js/plugins/validation.js';
import { sentryInit } from '@js/plugins/sentry.js';
sentryInit();

Vue.use(DantesPlugin);
Vue.use(DantesValidation);

// Global components
Vue.component('DIcon', DantesIcon);

if (document.getElementById('app')) {
    /* Register our main Vue instance */

    var vm = new Vue({
        el: '#app',
        components: {
            // Pages
            'tech-support': () => import('@js/pages/TechSupport.vue'),
            'academic-help-desk': () => import('@js/pages/AcademicHelpDesk.vue'),
            'marketing-resources': () => import('@js/pages/MarketingResources.vue'),
            // Components
            'the-header': () => import('@js/components/TheHeader.vue'),
            'course-button': () => import('@js/components/CourseButton.vue'),
            'hero-section': () => import('@js/components/HeroSection.vue'),
            'hero-split': () => import('@js/components/HeroSplit.vue'),
            'how-it-works': () => import('@js/components/HowItWorks.vue'),
            'cta-section': () => import('@js/components/CtaSection.vue'),
            'checked-list-section': () => import('@js/components/CheckedListSection.vue'),
            'icon-points-section': () => import('@js/components/IconPointsSection.vue'),
            'split-section': () => import('@js/components/SplitSection.vue'),
            'slanted-section': () => import('@js/components/SlantedSection.vue'),
            'boxes-section': () => import('@js/components/BoxesSection.vue'),
            'd-accordion': () => import('@js/components/DantesAccordion.vue'),
            'd-accordion-panel': () => import('@js/components/DantesAccordionPanel.vue'),
        },
        store: store,
    });
} else {
    console.warn('Vue not initialized, check Blade template!');
}
